import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { DashboardFilter, DashboardIncomeChart } from "components/organisms";
import { DashboardSummary, OccupancyChart } from "components/molecules";

import {
	getDashboardReport,
	getDashboardYearReport,
	getDashboardYearReportLoading,
} from "state/modules/dashboard";

import { FONT_FAMILY_BOLD, FONT_WEIGHT_BOLD } from "styles/typography";
import { MAIN_THEME } from "styles/colors";

const FilterContainer = styled.div`
	position: relative;
	z-index: 11;
`;

const SummaryContainer = styled.div`
	margin-bottom: 20px;
	z-index: 0;
`;

const Container = styled.div`
	width: 100%;
	padding: 20px 30px;
	overflow: auto;
	background: ${MAIN_THEME.DARK_BG};

	@media (max-width: 1200px) {
		padding: 15px 20px;
	}

	@media (max-width: 768px) {
		padding: 15px 15px 90px;
	}

	@media (max-width: 480px) {
		padding: 10px 10px 80px;
	}
`;

const ChartsContainer = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: calc(100% - 295px) 280px;
	gap: 15px;
	height: 600px;

	@media (max-width: 1200px) {
		grid-template-columns: 1fr;
		height: auto;
	}

	@media (max-width: 768px) {
		gap: 10px;
		height: auto;
	}
`;

const Title = styled.p`
	font-size: 32px;
	font-family: ${FONT_FAMILY_BOLD};
	font-weight: ${FONT_WEIGHT_BOLD};
	color: ${MAIN_THEME.TEXT_PRIMARY};
	padding: 30px 0 20px;

	@media (max-width: 768px) {
		font-size: 24px;
		padding: 20px 0 15px;
	}

	@media (max-width: 480px) {
		font-size: 22px;
		padding: 15px 0 10px;
	}
`;

const Dashboard = () => {
	const dispatch = useDispatch();

	const isYearReportLoading = useSelector(getDashboardYearReportLoading);

	useEffect(() => {
		dispatch(getDashboardReport());
		dispatch(getDashboardYearReport());
	}, [dispatch]);

	return (
		<Container>
			<Title>Dashboard</Title>
			<div style={{ marginBottom: '20px' }}>
				<DashboardFilter />
			</div>
			<SummaryContainer>
				<DashboardSummary />
			</SummaryContainer>
			<ChartsContainer>
				<DashboardIncomeChart isLoading={isYearReportLoading} />
				<OccupancyChart isLoading={isYearReportLoading} />
			</ChartsContainer>
		</Container>
	);
};

export default Dashboard;
